export default __webpack_public_path__ + "static/831-d0ad372a6ef629f9208a0d8e9899cc4b.gif";